// extracted by mini-css-extract-plugin
module.exports = {"filters":"AttendancesReports_filters__MHpup","item":"AttendancesReports_item__169fg"};